import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, SalesOrderPurchaseAllocation, TmsWebBaseEditCreateService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderPurchaseAllocationService extends TmsWebBaseEditCreateService<
  SalesOrderPurchaseAllocation,
  SalesOrderPurchaseAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SalesOrderPurchaseAllocation', $localize`Sales Order Purchase Allocation`, httpService, notificationService);
  }

  allocate(salesOrderLineId: string, purchaseOrderLineId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      salesOrderLineId,
      purchaseOrderLineId,
    });
  }

  updateSalesOrderPurchaseAllocation(salesOrderPurchaseAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateSalesOrderPurchaseAllocation`, {
      salesOrderPurchaseAllocationId,
      quantity,
    });
  }

  getAllocations(salesOrderLineId: any): Observable<SalesOrderPurchaseAllocation[]> {
    return this.httpService.get<SalesOrderPurchaseAllocation[]>(
      `${this.apiUrl}/GetAllocations?salesOrderLineId=${salesOrderLineId}`,
    );
  }
}
